import styled from "@emotion/styled";
import theme from "../../styles/theme";

export const ImageAndCaptionBase = styled.div`
  padding: 0 ${theme.spacing[4]};
  text-align: center;
`;

export const Caption = styled.div`
  margin-top: ${theme.spacing[4]};
  color: ${theme.colors.darkBlues[75]};
  font-size: ${theme.fontSizes[0]};
`;
